export default "__VITE_ASSET__BlbYT8Wf__"